import StrapiProgressiveImage from "./StrapiProgressiveImage";
import { Popover } from "antd";
import React from "react";
import { StrapiImage } from "typings/strapi";

const JoinPurpleTeamIcon: React.FC<{
  name: string;
  icon: StrapiImage;
  imageClassName: string;
  description: string;
}> = ({ name, icon, imageClassName, description }) => {
  const TeamDescription = <div>{description}</div>;

  return (
    <Popover content={TeamDescription} title={name}>
      <div>
        <StrapiProgressiveImage image={icon} className={imageClassName} />
        <h1>{name}</h1>
      </div>
    </Popover>
  );
};

export default JoinPurpleTeamIcon;
